/* eslint-disable no-unused-vars */
import React, {Component} from "react";
import {InputLabel, withStyles, Select, MenuItem} from "@material-ui/core";
import classNames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import {API} from "../../../config";
import Util from "../../../yeffect/utils";
const country = API.service('country');

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class CountrySelect extends Component {
    state = {
        active:     this.props.active || 1,
        countries: false
    };

    componentDidMount() {
        const app = this;
        country.find({ query: { $sort: { _short_name: 1 } } }).then(c => {
            console.log(c);
            app.setState({
                countries: c.data
            })
        });
    }

    render() {
        const { classes, possibleValues, value, width, onChange, fieldLabel, fieldName, errorFields} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <FormControl className={classNames('w-full')} >
                        <InputLabel shrink={(!Util.isEmpty(value) || value === false)} id={fieldName + '_label'}>{fieldLabel} {(this.props.required === true) ? '*' :''}</InputLabel>
                        <Select
                            labelId={fieldName + '_label'}
                            id={fieldName}
                            value={value}
                            label="Age"
                            name={fieldName}
                            onChange={onChange}
                            error={!(typeof errorFields[fieldName] === "undefined")}
                            helperText={(typeof errorFields[fieldName] !== "undefined") ? errorFields[fieldName] : false}
                            required={this.props.required}
                            >


                            <option value=""> </option>
                            {(this.state.countries !== false) &&
                                this.state.countries.map(o => {
                                    return (
                                        <MenuItem value={o._iso2}>{o._short_name}</MenuItem>
                                    )

                                })
                            }
                        </Select>
                    </FormControl>

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CountrySelect);


// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/CountrySelect.js